import { request as httpRequest } from './http-library.js';
import publicConfig from '../public-config.js';
const ssoHost = publicConfig.external_address;

export const Nux = {
  read: function readNux (query, accessToken, callback) {
    const uxQuery = query ? '?' + query : '';
    const requestParams = {
      host: ssoHost,
      path: '/v1/profiles/me/experience' + uxQuery,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + accessToken
      }
    };
    httpRequest(requestParams, function (response) {
      callback(response);
    }, null);
  }
};
